/** Same-origin cover for a campaign. `v` is the asset id so a replace busts cache. */
export function campaignCoverUrl(campaignId: string, assetId?: string | null): string {
  if (!campaignId) return "";
  const q = assetId ? `?v=${encodeURIComponent(assetId)}` : "";
  return `/api/v1/campaigns/${campaignId}/cover${q}`;
}
